import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/brand";

export default function Logo({ size = 36, showWordmark = true, dataTestId }) {
  return (
    <Link
      to="/"
      data-testid={dataTestId || "logo-link"}
      className="inline-flex items-center gap-3 group"
      aria-label="BrandLabAI home"
    >
      <span
        className="inline-flex items-center justify-center rounded-full overflow-hidden transition-transform duration-300 group-hover:scale-[1.04]"
        style={{ width: size, height: size, background: "#FFFFFF" }}
      >
        <img
          src={LOGO_URL}
          alt="Brandlab AI logomark"
          width={size}
          height={size}
          loading="eager"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </span>
      {showWordmark && (
        <span className="font-display font-bold text-[1.05rem] tracking-tight leading-none">
          <span className="text-brand">Brandlab</span>{" "}
          <span style={{ color: "var(--brand-primary)" }}>AI</span>
        </span>
      )}
    </Link>
  );
}
